export default __webpack_public_path__ + "static/media/otp.5341a46e.png";